export default __webpack_public_path__ + "static/media/Fala Kolista.66c23628.png";